import { getEnv } from "../config/env";

const awsRegion = getEnv("REACT_APP_AWS_REGION");

const AWSIoTConfig = {
  Auth: {
    identityPoolId: getEnv(
      "REACT_APP_COGNITO_IDENTITY_POOL_ID"
    ),
    region: awsRegion,
    
    userPoolId: getEnv("REACT_APP_COGNITO_USER_POOL_ID"), 
    userPoolWebClientId: getEnv(
      "REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID"
    ),
    
    mandatorySignIn: false,
    authenticationFlowType: 'USER_SRP_AUTH'
  },
  aws_project_region: awsRegion,
  aws_cognito_region: awsRegion,
  aws_pubsub_region: awsRegion,
  aws_pubsub_endpoint: getEnv(
    "REACT_APP_AWS_PUBSUB_ENDPOINT"
  ),
};

export default AWSIoTConfig;
